import React from 'react';

function Languages(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.87 15.07L10.33 12.56L10.36 12.53C12.1 10.59 13.34 8.36 14.07 6H17V4H10V2H8V4H1V5.99H12.17C11.5 7.91 10.44 9.74 9 11.38C8.07 10.35 7.29 9.21 6.69 7.99H4.67C5.44 9.63 6.5 11.17 7.8 12.64L2.71 17.66L4.12 19.07L9.12 14.07L12.23 17.14L12.87 15.07ZM18.5 10H16.5L12 22H14L15.12 19H19.88L21 22H23L18.5 10ZM15.88 17L17.5 12.67L19.12 17H15.88Z"
                fill={props.color}
            />
        </svg>
    );
}

export default Languages;
